/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button, FLink, TextInfo } from '@components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { plans } from '@utils';
import {
  BENEFICIOS,
  EXTRADO_SALDO_CONTAS,
  INFORME_RENDIMENTOS,
  MEUS_DADOS,
} from '../../../common/utils/paths';
import { PlanoParticipanteService } from '../../../common/services/planoParticipante';

export const ExtratoPage = () => {
  const navigate = useNavigate();
  const dadosPessoais = useSelector((state) => state.user.dadosPessoais);
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const pages = useSelector((state) => state.user.extrato?.habilitar);
  const cnpb = useSelector((state) => state.user.extrato?.cnpb);

  const [loading, setLoading] = useState(false);
  const [certificadoAdesao, setCertificadoAdesao] = useState('');

  const obterUrlAdesao = useCallback(async () => {
    setLoading(true);
    const planoParticipanteService = new PlanoParticipanteService();
    const data = await planoParticipanteService.obterCertificadoAdesao(
      matricula,
      token
    );

    // valida se o pdf possui dados
    if (data.byteLength > 52) {
      setCertificadoAdesao(data);
    }

    setLoading(false);
  }, [matricula, token]);

  useEffect(() => {
    obterUrlAdesao();
  }, [obterUrlAdesao]);

  return (
    <>
      <Helmet>
        <title>Forluz - Extrato Participante</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Extrato Participante</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body pb-0">
          <h3 className="text-orange">
            <strong>Participante</strong>
          </h3>
          <TextInfo text="Matricula" info={matricula} />
          <TextInfo text="Nome" info={dadosPessoais.nome} />
          <TextInfo text="Plano" info={`Plano ${plans[plano]}`} />
          <TextInfo text="CNPB" info={cnpb} />
        </div>
        <div className="card-body d-flex flex-column gap-3">
          {pages.CertificadoAdesao && (
            <div>
              <h3 className="text-orange">
                <strong>Certificado de Adesão</strong>
              </h3>
              {loading ? (
                <span>Carregando...</span>
              ) : (
                <div>
                  {certificadoAdesao ? (
                    <span>
                      Para visualizar seu Certificado de Adesão,{' '}
                      <button
                        onClick={() => {
                          const blob = new Blob([certificadoAdesao], {
                            type: 'application/pdf',
                          });
                          const link = document.createElement('a');
                          link.href = window.URL.createObjectURL(blob);
                          link.download = `Certificado de adesão - ${matricula}.PDF`;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        className="link d-inline fs-6"
                        style={{
                          padding: 0,
                          border: 'none',
                          background: 'white',
                        }}
                      >
                        clique aqui.
                      </button>
                    </span>
                  ) : (
                    <span>
                      Seu Certificado de Adesão foi enviado para seu e-mail
                      corporativo logo após o processamento da inscrição. Por
                      favor, verifique sua caixa de entrada.
                    </span>
                  )}
                </div>
              )}
            </div>
          )}

          {pages.Beneficiarios && (
            <div>
              <h3 className="text-orange">
                <strong>Dependentes e Beneficiário</strong>
              </h3>
              <span>
                Para visualizar seus Dependentes e Beneficiários,{' '}
                <button
                  onClick={() =>
                    navigate(MEUS_DADOS, {
                      state: 'Beneficiarios',
                    })
                  }
                  className="link d-inline fs-6"
                  style={{
                    padding: 0,
                    border: 'none',
                    background: 'white',
                  }}
                >
                  clique aqui.
                </button>
              </span>
            </div>
          )}

          {pages.ExtratoSaldoContas && (
            <div>
              <h3 className="text-orange">
                <strong>Emitir Extrato e Saldo de Contas</strong>
              </h3>
              <span>
                Para visualizar o extrato da sua conta individualizada de
                aposentadoria, com a discriminação das parcelas constituídas
                pelas contribuições do participante, patrocinador ou terceiros,
                bem como o saldo de portabilidade, quando houver, que
                possibilite o acompanhamento da rentabilidade dos recursos,{' '}
                <FLink to={EXTRADO_SALDO_CONTAS} className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          )}

          {pages.InformeRendimentos && (
            <div>
              <h3 className="text-orange">
                <strong>Informe de Rendimentos</strong>
              </h3>
              <span>
                Para visualizar seu demonstrativo de vencimentos anual para
                imposto de renda,{' '}
                <FLink to={INFORME_RENDIMENTOS} className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          )}

          {/* pages.ExaurimentoBeneficio && (
            <div>
              <h3 className="text-orange">
                <strong>Tempo de Exaurimento do Benefício</strong>
              </h3>
              <span>
                Para conhecer a projeção do exaurimento do seu benefício,{' '}
                <FLink to="/" className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          ) */}

          {pages.SimuladorBeneficio && (
            <div>
              <h3 className="text-orange">
                <strong>Simulador de Benefícios</strong>
              </h3>
              <span>
                Para simular seu benefício na Forluz,{' '}
                <FLink to={BENEFICIOS} className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          )}

          {/* pages.Contribuicoes && (
            <div>
              <h3 className="text-orange">
                <strong>Destinação das Contribuições</strong>
              </h3>
              <span>
                Para visualizar as parcelas das contribuições efetuadas pelo
                participante, partrocinador ou instituidor, eventualmente
                destinadas a benefício de risco e a custeio de despesas
                administrativas,{' '}
                <FLink to="/" className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          ) */}

          {/* mockShow.solicitacao && (
            <div>
              <h3 className="text-orange">
                <strong>
                  Solicitação de Informação por Participante ou Assistido
                </strong>
              </h3>
              <span>
                Para acessar as orientações de informações para solicitação de
                informação por participante ou assistido,{' '}
                <FLink to="/" className="d-inline fs-6">
                  clique aqui.
                </FLink>
              </span>
            </div>
          ) */}

          <div>
            <h3 className="text-orange">
              <strong>
                Solicitação de Informação por Participante ou Assistido
              </strong>
            </h3>
            <span>
              As orientações de informações para solicitação de informação por
              participante ou assistido, podem ser acessadas no Portal da Forluz
              através do menu: Contato {'>'} Acesso a Informação ou,{' '}
              <a
                href="https://institucional.forluz.org.br/Transparencia/acesso-informacao"
                rel="noreferrer"
                target="_blank"
                title="Institucional"
                className="mb-2 text-orange fw-bold text-decoration-none fs-6"
              >
                clique aqui.
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
